<template>
  <teleport to="body">
    <div v-if="visible" class="modal-backdrop" @click="closeModal" aria-hidden="true"></div>

    <div v-if="visible" class="modal-content" role="dialog" aria-modal="true" :aria-label="title || $t('ver_fichajes')">
      <div class="modal-header">
      try { this.applySorting(); } catch (e) {}
        <h3 class="modal-title">{{ title || $t('ver_fichajes') }}</h3>
        <button type="button" class="btn-close" @click.stop="closeModal" aria-label="Cerrar" title="Cerrar">
          <span class="material-icons">close</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="filter-container">
          <template v-if="!fixedUserId">
            <label for="filter-user">{{ $t('usuario') }}</label>
            <select id="filter-user" v-model="selectedUserId" @change="applyFilters">
              <option value="">-- {{ $t('todos') }} --</option>
              <option v-for="u in usersList" :key="u.id" :value="u.id">{{ u.fullName }}</option>
            </select>
          </template>

          <label for="filter-date-from">{{ $t('filtrar_fecha') }}</label>
          <input id="filter-date-from" type="date" v-model="dateFrom" @change="applyFilters" />
          <label for="filter-date-to">&nbsp;→</label>
          <input id="filter-date-to" type="date" v-model="dateTo" @change="applyFilters" />

          <button type="button" class="icon-button" @click="clearDateFilter" :title="$t('borrar_filtro')" :aria-label="$t('borrar_filtro')">
            <span class="material-icons">filter_alt_off</span>
          </button>
          <button type="button" class="icon-button export" @click="exportToExcel" :title="$t('exportar_logs')" :aria-label="$t('exportar_logs')">
            <span class="material-icons">file_download</span>
          </button>
        </div>

        <div class="logs-container">
          <table class="logs-table fichajes-table">
            <thead>
              <tr>
                <th>
                  {{ $t('id') }}
                  <span class="th-sort-control" role="button" tabindex="0" @click="setSort('id')" style="margin-left:6px; font-size:0.9em; cursor:pointer;"> <span v-if="sortBy==='id'">{{ sortDir==='asc' ? '▲' : '▼' }}</span><span v-else>⇅</span></span>
                </th>
                <th>
                  {{ $t('usuario') }}
                  <span class="th-sort-control" role="button" tabindex="0" @click="setSort('usuario')" style="margin-left:6px; font-size:0.9em; cursor:pointer;"> <span v-if="sortBy==='usuario'">{{ sortDir==='asc' ? '▲' : '▼' }}</span><span v-else>⇅</span></span>
                </th>
                <th>
                  {{ $t('fecha') }}
                  <span class="th-sort-control" role="button" tabindex="0" @click="setSort('fecha')" style="margin-left:6px; font-size:0.9em; cursor:pointer;"> <span v-if="sortBy==='fecha'">{{ sortDir==='asc' ? '▲' : '▼' }}</span><span v-else>⇅</span></span>
                </th>
                <th>{{ $t('hora_inicio_manana') }}</th>
                <th>{{ $t('hora_fin_manana') }}</th>
                <th>{{ $t('hora_inicio_tarde') }}</th>
                <th>{{ $t('hora_fin_tarde') }}</th>
                <th>
                  {{ $t('motivo_comentario') }}
                  <span class="th-sort-control" role="button" tabindex="0" @click="setSort('comentario')" style="margin-left:6px; font-size:0.9em; cursor:pointer;"> <span v-if="sortBy==='comentario'">{{ sortDir==='asc' ? '▲' : '▼' }}</span><span v-else>⇅</span></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="filteredFichajes.length === 0">
                <td :colspan="8" style="text-align:center">{{ $t('no_registros') }}</td>
              </tr>
              <tr v-for="f in filteredFichajes" :key="f.id">
                <td>{{ f.id }}</td>
                <td>{{ f.usuario?.nombre_completo || f.usuario_id || '-' }}</td>
                <td>{{ formatDate(f.fecha) }}</td>
                <td>{{ formatTime(f.hora_inicio_manana) || '-' }}</td>
                <td>{{ formatTime(f.hora_fin_manana) || '-' }}</td>
                <td>{{ formatTime(f.hora_inicio_tarde) || '-' }}</td>
                <td>{{ formatTime(f.hora_fin_tarde) || '-' }}</td>
                <td class="comentario-cell">{{ f.comentario || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="close-btn" @click="closeModal">{{ $t('cerrar') }}</button>
      </div>
    </div>
  </teleport>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  name: 'UserFichajesModalView',
  props: {
    visible: { type: Boolean, default: false },
    fichajes: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    fixedUserId: { type: [String, Number, null], default: null }
  },
  emits: ['update:visible'],
  data() {
    return {
      dateFrom: '',
      dateTo: '',
      selectedUserId: '',
      filteredFichajes: [],
      // Sorting
      sortBy: null,
      sortDir: 'desc'
    };
  },
  watch: {
    fichajes: {
      immediate: true,
      handler(val) {
        let arr = Array.isArray(val) ? [...val] : [];
        // Si el modal fue abierto con un usuario fijo, forzamos el filtrado por ese usuario
        if (this.fixedUserId !== null && this.fixedUserId !== undefined && this.fixedUserId !== '') {
          const uidStr = String(this.fixedUserId);
          arr = arr.filter(f => {
            const uid = f.usuario?.id || f.usuario_id || f.usuario?.usuario_id;
            return String(uid) === uidStr;
          });
          // Asegurarnos también de que el selectedUserId refleje el fixedUserId
          this.selectedUserId = uidStr;
        }
        this.filteredFichajes = this.sortByDate(arr);
      }
    },
    fixedUserId: {
      immediate: true,
      handler(id) {
        // if a fixed user id is provided, set the selectedUserId and prefilter
        if (id !== null && id !== undefined && id !== '') {
          this.selectedUserId = String(id);
          this.applyFilters();
        }
      }
    },
    visible(newVal) {
      if (newVal) {
        this._previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = this._previousBodyOverflow || '';
        this._previousBodyOverflow = null;
        // collapse details when closing
        // collapse details when closing (no-op since details removed)
        this.expanded = {};
      }
    }
  },
  methods: {
    closeModal() { this.$emit('update:visible', false); },
    applyFilters() {
      let results = Array.isArray(this.fichajes) ? [...this.fichajes] : [];
      if (this.selectedUserId) {
        results = results.filter(f => {
          const uid = f.usuario?.id || f.usuario_id || f.usuario?.usuario_id;
          return String(uid) === String(this.selectedUserId);
        });
      }
      if (this.dateFrom || this.dateTo) {
        results = results.filter(f => {
          const raw = f.fecha || f.created_at || '';
          const dateOnly = raw.toString().slice(0,10);
          if (!dateOnly) return false;
          if (this.dateFrom && this.dateTo) return dateOnly >= this.dateFrom && dateOnly <= this.dateTo;
          if (this.dateFrom) return dateOnly >= this.dateFrom;
          if (this.dateTo) return dateOnly <= this.dateTo;
          return true;
        });
      }
      this.filteredFichajes = this.sortByDate(results);
    },
    clearDateFilter() { this.dateFrom = ''; this.dateTo = ''; this.selectedUserId = ''; this.filteredFichajes = this.sortByDate([...this.fichajes]); },
    setSort(column) {
      if (this.sortBy === column) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortBy = column;
        this.sortDir = column === 'fecha' ? 'desc' : 'asc';
      }
      this.applySorting();
    },
    applySorting() {
      if (!this.sortBy) return;
      const col = this.sortBy;
      const dir = this.sortDir === 'asc' ? 1 : -1;
      this.filteredFichajes.sort((a, b) => {
        if (col === 'fecha') {
          return dir * (this.parseDateForSort(a?.fecha) - this.parseDateForSort(b?.fecha));
        }
        if (col === 'id') {
          return dir * ((a?.id || 0) - (b?.id || 0));
        }
        if (col === 'usuario') {
          const na = (a.usuario?.nombre_completo || '').toString().toLowerCase();
          const nb = (b.usuario?.nombre_completo || '').toString().toLowerCase();
          return dir * na.localeCompare(nb, undefined, { sensitivity: 'base', numeric: true });
        }
        if (col === 'comentario') {
          const ca = (a.comentario || '').toString().toLowerCase();
          const cb = (b.comentario || '').toString().toLowerCase();
          return dir * ca.localeCompare(cb, undefined, { sensitivity: 'base', numeric: true });
        }
        return 0;
      });
    },
    // Convierte distintos formatos de fecha a timestamp para ordenar
    parseDateForSort(raw) {
      if (!raw) return 0;
      try {
        if (raw instanceof Date) return raw.getTime();
        const s = raw.toString();
        // Si es YYYY-MM-DD
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
          return new Date(s + 'T00:00:00').getTime();
        }
        // Intentar parseo directo (ISO u otros)
        const t = Date.parse(s);
        if (!isNaN(t)) return t;
        // Ultimo recurso: extraer YYYY-MM-DD y parsear
        const maybe = s.slice(0,10);
        if (/^\d{4}-\d{2}-\d{2}$/.test(maybe)) return new Date(maybe + 'T00:00:00').getTime();
      } catch (e) {
        return 0;
      }
      return 0;
    },
    // Ordena array por fecha (newest first). Devuelve el mismo array ordenado.
    sortByDate(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.sort((a, b) => {
        // Priorizar siempre el campo 'fecha'
        const ta = this.parseDateForSort(a?.fecha);
        const tb = this.parseDateForSort(b?.fecha);
        if (ta && tb) {
          if (tb !== ta) return tb - ta; // newest first
        } else if (ta && !tb) {
          return -1 * -1; // a tiene fecha, b no -> a primero (tb - ta negative)
        } else if (!ta && tb) {
          return 1 * -1; // b tiene fecha, a no -> b primero
        }
        // Si ninguno tiene 'fecha' definido, hacer fallback a created_at para mantener orden determinista
        const tca = this.parseDateForSort(a?.created_at);
        const tcb = this.parseDateForSort(b?.created_at);
        if (tca || tcb) {
          if (tcb !== tca) return tcb - tca;
        }
        // fallback por id si las fechas son iguales o no disponibles
        const ida = a?.id || 0;
        const idb = b?.id || 0;
        return idb - ida;
      });
    },
    exportToExcel() {
      const header = [
        this.$t('id'), this.$t('usuario'), this.$t('fecha'), this.$t('hora_inicio_manana'), this.$t('hora_fin_manana'), this.$t('hora_inicio_tarde'), this.$t('hora_fin_tarde'), this.$t('motivo_comentario')
      ];
      const data = this.filteredFichajes.map(f => [
        f.id, f.usuario?.nombre_completo || f.usuario_id || '', this.formatDate(f.fecha) || '', this.formatTime(f.hora_inicio_manana) || '', this.formatTime(f.hora_fin_manana) || '', this.formatTime(f.hora_inicio_tarde) || '', this.formatTime(f.hora_fin_tarde) || '', f.comentario || ''
      ]);
      const allRows = [header, ...data];
      const ws = XLSX.utils.aoa_to_sheet(allRows);
      const colWidths = header.map((_, colIdx) => ({ wch: Math.max(...allRows.map(r => (r[colIdx] ? String(r[colIdx]).length : 0)), 10) }));
      ws['!cols'] = colWidths;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Fichajes');
      const timestamp = new Date().toISOString().slice(0,19).replace(/[:T]/g,'-');
            try { this.applySorting(); } catch (e) {}
      XLSX.writeFile(wb, `fichajes_${timestamp}.xlsx`);
    },
    formatDate(raw) {
      if (!raw) return '';
      // If raw is already a Date object
      try {
        let d;
        if (raw instanceof Date) {
          d = raw;
        } else if (typeof raw === 'string' && raw.indexOf('T') !== -1) {
          // Parse ISO datetime (e.g. 2026-03-22T23:00:00.000000Z)
          d = new Date(raw);
          if (isNaN(d.getTime())) {
            // Fallback: try removing fractional seconds
            const cleaned = raw.replace(/\.\d+Z$/, 'Z');
            d = new Date(cleaned);
          }
        } else {
          const parsed = Date.parse(raw);
          if (!isNaN(parsed)) {
            d = new Date(parsed);
          } else {
            // Fallback: string like YYYY-MM-DD -> keep original logic
            const s = raw.toString().slice(0,10);
            const parts = s.split('-');
            if (parts.length !== 3) return raw;
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
        }
        // Use local date parts so timezone offset doesn't subtract a day visually
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      } catch (e) {
        return raw;
      }
    },
    formatTime(raw) {
      if (!raw) return '';
      const s = raw.toString().trim();
      if (s === '00:00:00' || s === '00:00') return '';
      let timePart = s;
      if (s.indexOf(' ') !== -1) timePart = s.split(' ').pop();
      const parts = timePart.split(':');
      let hh = parts[0] || '00';
      let mm = parts[1] || '00';
      hh = String(hh).padStart(2, '0');
      mm = String(mm).padStart(2, '0').slice(0,2);
      return `${hh}:${mm}`;
    },
    // details expansion removed
  },
  computed: {
    usersList() {
      const map = new Map();
      (this.fichajes || []).forEach(f => {
        const u = f.usuario;
        const id = u?.id || f.usuario_id || null;
        const fullName = u?.nombre_completo || u?.name || String(f.usuario_id || id || '-');
        if (id) map.set(String(id), { id: String(id), fullName });
      });
      return Array.from(map.values()).sort((a, b) => {
        const na = (a.fullName || '').toString();
        const nb = (b.fullName || '').toString();
        return na.localeCompare(nb, undefined, { sensitivity: 'base' });
      });
    }
  }
};
</script>

<style scoped>
/* reuse styles similar to UserLogModal */
.modal-content { position: fixed !important; top: 55% !important; left: 50% !important; transform: translate(-50%, -50%) !important; z-index: 12000 !important; background-color: #ffffff !important; border-radius: 8px; width: 85%; max-width: 1100px; max-height: 80vh; overflow: visible; box-shadow: 0 10px 30px rgba(0,0,0,0.25); box-sizing: border-box; padding: 0; display: flex; flex-direction: column; }
.modal-backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 11990; }
.modal-header, .modal-footer { flex: 0 0 auto; padding: 10px 16px; }
.modal-header {
  /* Override para evitar que reglas globales (left: -20px) desplacen el header */
  margin-top: 0; /* evitar desplazamiento vertical no deseado */
  left: 0;      /* asegurar alineación horizontal */
  width: 100%;  /* prevenir expansion debido a calc(100% + 40px) */
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
}
.modal-body { flex: 1 1 auto; display:flex; flex-direction:column; padding: 12px; overflow: hidden; }
.logs-container { flex: 1 1 auto; overflow-y: auto; padding-bottom: 12px; }
.filter-container { display:flex; align-items:center; gap:8px; margin-bottom: 12px; }

 /* Tabla de fichajes */
.fichajes-table { width: 100%; border-collapse: collapse; font-size: 0.95rem; table-layout: auto; }
.fichajes-table th, .fichajes-table td { border: 1px solid #e6e6e6; padding: 8px 10px; text-align: left; vertical-align: middle; }

 /* Hacer más ancha la columna "usuario" (2) y que no haga wrap; si el nombre es demasiado largo muestra ellipsis */
.fichajes-table th:nth-child(2),
.fichajes-table td:nth-child(2) {
  min-width: 220px;
  max-width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Hacer más ancha la columna "fecha" (3) y evitar salto de línea */
.fichajes-table th:nth-child(3),
.fichajes-table td:nth-child(3) {
  min-width: 140px;
  white-space: nowrap;
}

/* Mantener las horas en su columna sin permitir wrap */
.fichajes-table th:nth-child(n+4),
.fichajes-table td:nth-child(n+4) {
  white-space: nowrap;
}

/* Comentario cell: limitar ancho y mostrar ellipsis si es muy largo */
.fichajes-table td.comentario-cell {
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Ajustes responsivos: reducir mínimos en pantallas pequeñas */
@media (max-width: 700px) {
  .fichajes-table th:nth-child(2),
  .fichajes-table td:nth-child(2) { min-width: 140px; max-width: 220px; }
  .fichajes-table th:nth-child(3),
  .fichajes-table td:nth-child(3) { min-width: 100px; }
  .modal-content { width: 95%; max-width: 980px; }
}

.modal-footer { background: #fff; border-top: 1px solid #eee; z-index: 20; }
.close-btn { background-color: #99172A; color: #fff; border: none; padding: 8px 12px; border-radius:4px }
.btn-export { background-color: #2e7d32; color: #fff; border: none; padding: 6px 10px; border-radius:4px }
/* Icon buttons for compact controls */
.icon-button { display:inline-flex; align-items:center; justify-content:center; width:36px; height:36px; border-radius:6px; border:none; background:transparent; cursor:pointer; color:#333; }
.icon-button .material-icons { font-size:20px }
.icon-button.export { color: #2e7d32 }

/* JSON details style */
/* details view removed */
</style>
